import {
  Button,
  InputGroup,
  InputSelect,
  NAME_REGEX,
  NO_REGEX,
  SWIFT_CODE_REGEX,
  color,
} from "@funded-here-interface/common";
import { FC, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useStyle } from "../../styles/BankDetailsCss";
import { useSelector } from "react-redux";
import { RootState } from "@funded-here-interface/investor-onboarding/src/store";
import { useDispatch } from "react-redux";
import {
  setBankNameRedux,
  setAccountNoRedux,
  setSwiftCodeReduct,
  setAccountTypeRedux,
  setAccountHolderNameRedux,
} from "../../features/indinvestor/bankSliceInd";
import { bankAccountTypes } from "../../constants/bank";
import BankAccNameDisclaimer from "../../components/BankAccNameDisclaimer/BankAccNameDisclaimer";
import { toast } from "react-toastify";
import useGetOrgDraft from "../../hooks/useGetOrgDraft";
import useSaveOrgDraft from "../../hooks/useSaveOrgDraft";

const BankDetailsInd: FC = () => {
  const { classes } = useStyle();
  const Navigate = useNavigate();
  const { userFirstName, userLastName } = useSelector(
    (state: RootState) => state.auth
  );

  const userId = useSelector((state: RootState) => state.auth.userId);
  const { token } = useSelector((state: RootState) => state.auth);

  const getOrgDraftMutation = useGetOrgDraft();
  const saveOrgDraftMutation = useSaveOrgDraft();

  const [initPage, setInitPage] = useState(true);

  const fetchDraft = async (userId: number) => {
    try {
      const params = {
        userId: userId,
        token: token,
      };
      const result = await getOrgDraftMutation.mutateAsync(params);
      return result;
    } catch (error) {
      console.error("Error fetching draft:", error);
    }
  };

  useEffect(() => {
    const initializeDraft = async () => {
      if (initPage) {
        try {
          const data = await fetchDraft(parseInt(userId));

          if (data) {
            setBankName(data.bankName);
            setAccountType(data.accountType);
            setAccountNumber(data.accountNumber);
            setAccountHolderName(data.accountHolderName);
            setSwiftCode(data.swiftCode);
          }
        } catch (error) {
          toast.error(`Error fetching draft: ${error}`);
        } finally {
          setInitPage(false);
        }
      }
    };

    initializeDraft();
  }, [initPage, userId]);

  const [bankName, setBankName] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [accountType, setAccountType] = useState("");
  const [swiftCode, setSwiftCode] = useState("");
  const [accountHolderName, setAccountHolderName] = useState("");
  const handleBack = () => {
    saveDraft(false);

    Navigate("/ind-biz-profile");
  };

  const [error, setError] = useState({
    bank_name: "",
    bankAccountNo: "",
    account_type: "",
    swift_code: "",
    accountType: "",
    accountHolderName: "",
  });

  const handleNext = () => {
    saveDraft(false);
    const customErr = { ...error };
    let valid = true;

    if (!bankName) {
      valid = false;
      customErr.bank_name = "Bank Name is required";
    }
    if (!swiftCode) {
      valid = false;
      customErr.swift_code = "Swift Code is required";
    }
    if (!accountNumber) {
      valid = false;
      customErr.bankAccountNo = "Bank Account no is required";
    }

    if (!accountType) {
      valid = false;
      customErr.accountType = "Account Type is required";
    }

    if (userFirstName && userLastName) {
      const userRegisteredName = `${userFirstName.toLowerCase()} ${userLastName.toLowerCase()}`;

      if (accountHolderName.toLowerCase() !== userRegisteredName) {
        valid = false;
        toast.warn("Account Holder Name should be the same as registered name");
      }
    }

    if (valid) {
      setTimeout(() => {
        Navigate("/doc-upload-ind");
      }, 500);
    } else {
      setError(customErr);
    }
  };

  const saveDraft = (showToast: Boolean = true) => {
    saveOrgDraftMutation.mutateAsync(
      {
        userId: parseInt(userId),
        token: token,
        bankName: bankName,
        accountNumber: accountNumber,
        accountHolderName: accountHolderName,
        accountType: accountType,
        swiftCode: swiftCode,
      },
      {
        onSuccess: () => {
          if (showToast) {
            toast.success("Draft Saved");
          }
        },
        onError: (e) => {
          toast.error((e as Error).message);
        },
      }
    );
  };

  return (
    <div style={{ marginTop: "70px" }}>
      <InputGroup
        isErrored={error.bank_name}
        onChange={(value: string) => {
          error.bank_name = "";
          setBankName(value.replace(NAME_REGEX, ""));
        }}
        labelText="Bank Name"
        id="bank_name"
        value={bankName}
      />

      <InputGroup
        isErrored={error.bankAccountNo}
        onChange={(value: string) => {
          error.bankAccountNo = "";
          setAccountNumber(value.replace(NO_REGEX, ""));
        }}
        labelText="Bank Account no."
        id="account_number"
        value={accountNumber}
      />
      <InputSelect
        isErrored={error?.accountType}
        onChange={(value: string) => {
          error.accountType = "";
          setAccountType(value);
        }}
        labelText="Account type"
        id="accountType"
        value={accountType}
        data={bankAccountTypes}
      />

      <InputGroup
        isErrored={error.swift_code}
        onChange={(value: string) => {
          error.swift_code = "";
          setSwiftCode(value.replace(SWIFT_CODE_REGEX, ""));
        }}
        labelText="SWIFT Code"
        value={swiftCode}
        id="swift_code"
      />
      <BankAccNameDisclaimer />
      <InputGroup
        isErrored={error.accountHolderName}
        onChange={(value: string) => {
          error.accountHolderName = "";
          setAccountHolderName(value);
        }}
        labelText="Account Holder Name (should match with registered name)"
        value={accountHolderName}
        id="account_holder_name"
      />

      <div className={classes.buttonDiv}>
        <div className={classes.buttonWrapper}>
          <Button
            onClick={handleBack}
            backgroundColor={color.WHITE}
            textColor={color.FHGREEN}
            children="Back"
            border="1px solid #338F86"
            width="100%"
          />
        </div>
        <div className={classes.buttonWrapper}>
          <Button
            onClick={handleNext}
            textColor={color.WHITE}
            backgroundColor={color.FHGREEN}
            children="Next"
            width="100%"
          />
        </div>
      </div>
      <div className={classes.buttonWrapper}>
        <Button
          onClick={saveDraft}
          textColor={color.WHITE}
          backgroundColor={color.LOANTEXT}
          children="Save Draft"
          width="100%"
        />
      </div>
    </div>
  );
};

export default BankDetailsInd;
